import { useActor } from '@xstate/react';
import { ReactComponent as CheckCircleGreenIcon } from 'assets/check-circle-green.svg';
import classNames from 'classnames';
import React from 'react';
import { SignUpFlowEventsTypes } from '../../../../../../../../signUpFlowMachine/signUpMachineEventTypes';
import {
  SignUpFlowMachineService,
  SIGN_UP_FLOW_STATES_NAME,
} from '../../../../../../../../signUpFlowMachine/signUpMachineTypes';
import { OTHER_OPTION } from '../../../../../2-UserInfo/constants';
import { OnboardingIcons } from '../../OnboardingQuestionIcons/OnboardingQuestionIcons';
import './CheckButton.scss';

type Props = {
  button: {
    text: string;
    action: () => void;
    isSelected?: boolean;
  };
  icon: OnboardingIcons;
  service: SignUpFlowMachineService;
  setStep: (value: React.SetStateAction<number>) => void;
};

export const CheckButton = (props: Props) => {
  const { button, service, icon, setStep } = props;
  const [current, send] = useActor(service);
  const isGoalStep = current.matches(SIGN_UP_FLOW_STATES_NAME.GOAL);
  const isIndustryStep = current.matches(SIGN_UP_FLOW_STATES_NAME.INDUSTRY);

  const { text, action, isSelected } = button;
  const classname = classNames('check-button', {
    'check-button--selected': isSelected,
    'check-button--goal-step': isGoalStep,
  });

  const onClick = () => {
    if (text === OTHER_OPTION) {
      if (isIndustryStep) {
        send(SignUpFlowEventsTypes.SET_OTHER_INDUSTRY);
      }
    } else {
      action();
    }
    setStep(prev => prev + 1);
  };

  return (
    <div className={classname} onClick={onClick} key={button.text}>
      <img src={icon?.toString()} className="check-button__button-icon" />
      {isSelected && (
        <div className="check-button__icon-container">
          <CheckCircleGreenIcon className="check-button__icon" />
        </div>
      )}
      {text}
    </div>
  );
};
